export default "__VITE_ASSET__Dj0Kv9Fz__"